import { useDecision } from '@optimizely/react-sdk'

// Kill-switch deciding which hero variant GoustoAnytimeDashboard's empty-state banner renders —
// see selectHeroSection in @features/my-gousto-page. Kept in its own hook rather than folded into
// useGoustoAnytimeDashboard, which is about fetching the dashboard's data and gating the whole
// experience, not one section's rendering variant.
export const NEW_HERO_BANNER_FLAG = 'tomatoes_ofx_webclient_empty_state_banner_v2'

export function useGoustoAnytimeEmptyStateBannerFlag(): boolean {
  const [decision] = useDecision(NEW_HERO_BANNER_FLAG)

  return decision.enabled
}
